export const esMX = {
  'Not scheduled': 'Sin programar',
  'View Work Order': 'Ver orden de trabajo',
  'Back to Work Orders': 'Volver a órdenes de trabajo',
  'Unable to load work order': 'No se pudo cargar la orden de trabajo',
  'View Inspection Report': 'Ver informe de inspección',
  'Not rated': 'Sin evaluar',
  'Safety Issue': 'Problema de seguridad',
  'Needs Attention': 'Requiere atención',
  'Satisfactory': 'Satisfactorio',
  'Leak Detection Report': 'Informe de detección de fugas',
  'Pool Inspection Report': 'Informe de inspección de piscina',
  'Inspection cover photo': 'Foto de portada de la inspección',
  'Access Your Portal': 'Entrar a tu portal',
  'Agreement': 'Contrato',
  'Amount': 'Importe',
  'Amount Due': 'Importe pendiente',
  'Approve': 'Aprobar',
  'Balance Due': 'Saldo pendiente',
  'Back': 'Volver',
  'Back to Invoices': 'Volver a facturas',
  'Back to Service History': 'Volver al historial de servicio',
  'Calcium Hardness': 'Dureza de calcio',
  'Cancel': 'Cancelar',
  'Chemical Readings': 'Lecturas químicas',
  'Chemicals Added': 'Químicos agregados',
  'Close': 'Cerrar',
  'Combined Chlorine': 'Cloro combinado',
  'Completed': 'Completado',
  'Contact': 'Contacto',
  'Contact Us': 'Contáctanos',
  'Customer Portal': 'Portal del cliente',
  'Cyanuric Acid (CYA)': 'Ácido cianúrico (CYA)',
  'Date': 'Fecha',
  'Decline': 'Rechazar',
  'Description': 'Descripción',
  'Download Invoice': 'Descargar factura',
  'Download PDF': 'Descargar PDF',
  'Due Date': 'Fecha de vencimiento',
  'Email': 'Correo electrónico',
  'Free Chlorine': 'Cloro libre',
  'Home': 'Inicio',
  'Invoice': 'Factura',
  'Issued': 'Emitida',
  'Invoices': 'Facturas',
  'Last Service': 'Último servicio',
  'Loading...': 'Cargando...',
  'Log Out': 'Cerrar sesión',
  'Sign Out': 'Cerrar sesión',
  'Main navigation': 'Navegación principal',
  'Menu': 'Menú',
  'No invoices yet': 'Aún no hay facturas',
  'No service history yet': 'Aún no hay historial de servicio',
  'No services yet': 'Aún no hay servicios',
  'Notes': 'Notas',
  'Open navigation menu': 'Abrir menú de navegación',
  'Paid': 'Pagada',
  'Pay Invoice': 'Pagar factura',
  'Payment': 'Pago',
  'Payment History': 'Historial de pagos',
  'Phone': 'Teléfono',
  'Photos': 'Fotos',
  'Properties': 'Propiedades',
  'Quote': 'Cotización',
  'Recent Service History': 'Historial de servicio reciente',
  'Salt': 'Sal',
  'Scheduled Work': 'Trabajo programado',
  'Service Agreement': 'Contrato de servicio',
  'Service Details': 'Detalles del servicio',
  'Service Checklist': 'Lista de servicio',
  'Service Photos': 'Fotos del servicio',
  'Service Time': 'Hora del servicio',
  'Service History': 'Historial de servicio',
  'Services': 'Servicios',
  'Status': 'Estado',
  'Submit': 'Enviar',
  'Subtotal': 'Subtotal',
  'Total': 'Total',
  'Total Alkalinity': 'Alcalinidad total',
  'Total Chlorine': 'Cloro total',
  'View All': 'Ver todo',
  'View Details': 'Ver detalles',
  'Void': 'Anulada',
  'Water Temperature': 'Temperatura del agua',
  'Water Temp': 'Temperatura del agua',
  'Work': 'Trabajo',
  'Work Orders': 'Órdenes de trabajo',
  'Outstanding Invoices': 'Facturas pendientes',
  'Technician': 'Técnico',
  'Technician Notes': 'Notas del técnico',
  'Body of Water': 'Cuerpo de agua',
  'Cyanuric Acid': 'Ácido cianúrico',
  'Filter PSI': 'PSI del filtro',
  'Ideal': 'Ideal',
  'Phosphates': 'Fosfatos',
  'Service skipped': 'Servicio omitido',
  'Service record not found': 'No se encontró el registro de servicio',
  'Photo': 'Foto',
  'Property': 'Propiedad',
  'Qty': 'Cant.',
  'Unit Price': 'Precio unitario',
  'Tax': 'Impuesto',
  'Terms & Conditions': 'Términos y condiciones',
  'Upon receipt': 'Al recibirla',
  'View and pay your invoices': 'Consulta y paga tus facturas',
  'Your invoices will appear here': 'Tus facturas aparecerán aquí',
  'View your complete service history and reports': 'Consulta tu historial de servicio y tus reportes',
  'Your service records will appear here after your first visit': 'Tus registros de servicio aparecerán aquí después de la primera visita',
  'Chemical readings': 'Lecturas químicas',
  'photo': 'foto',
  'photos': 'fotos',
  'Pending': 'Pendiente',
  'Sent': 'Enviada',
  'Overdue': 'Vencida',
  'Skipped': 'Omitido',
  'Approved': 'Aprobada',
  'Declined': 'Rechazada',
  'Closed': 'Cerrado',
  'Line Items': 'Conceptos',
  'Method': 'Método',
  'Upcoming': 'Próximas',
  'In Progress': 'En progreso',
  'Scheduled': 'Programada',
  'No upcoming work orders': 'No hay próximas órdenes de trabajo',
  'No completed work orders yet': 'Aún no hay órdenes de trabajo completadas',
  'When you have upcoming scheduled work, it will appear here': 'El trabajo programado aparecerá aquí',
  'Completed work orders and service reports will appear here': 'Las órdenes completadas y los reportes de servicio aparecerán aquí',
  'View your scheduled and completed work orders': 'Consulta tus órdenes de trabajo programadas y completadas',
  'View Service Report': 'Ver reporte de servicio',
  'Est. Duration': 'Duración estimada',
  'Business Hours': 'Horario de atención',
  'Follow Us': 'Síguenos',
  'Contact us for business hours': 'Contáctanos para conocer el horario',
  'Unable to load contact information': 'No se pudo cargar la información de contacto',
  'Get in touch with {{businessName}}': 'Comunícate con {{businessName}}',
  'Sunday': 'Domingo',
  'Monday': 'Lunes',
  'Tuesday': 'Martes',
  'Wednesday': 'Miércoles',
  'Thursday': 'Jueves',
  'Friday': 'Viernes',
  'Saturday': 'Sábado',
  'Invoice not found': 'No se encontró la factura',
  'Service Period': 'Periodo de servicio',
  'Pay Now': 'Pagar ahora',
  'Pay by Card': 'Pagar con tarjeta',
  'Pay by Bank Account': 'Pagar con cuenta bancaria',
  'Your bank payment is processing. This can take 3-5 business days to clear.': 'Tu pago bancario se está procesando. Puede tardar de 3 a 5 días hábiles en acreditarse.',
  'Failed to create payment session': 'No se pudo iniciar el pago',
  'Welcome, {{name}}': 'Hola, {{name}}',
  'Your {{businessName}} customer portal': 'Tu portal de cliente de {{businessName}}',
  'Something went wrong. Please try again.': 'Algo salió mal. Inténtalo de nuevo.',
  'This link is invalid or has expired.': 'Este enlace no es válido o ya venció.',
  'Unable to connect. Please try again later.': 'No se pudo conectar. Inténtalo de nuevo más tarde.',
  'Verifying your access...': 'Verificando tu acceso...',
  'Check Your Email': 'Revisa tu correo electrónico',
  "If an account exists for {{email}}, we've sent a login link. Check your inbox and click the link to sign in.": 'Si existe una cuenta para {{email}}, enviamos un enlace de acceso. Revisa tu bandeja de entrada y selecciona el enlace para iniciar sesión.',
  'Use a different email': 'Usar otro correo electrónico',
  'Sign in to view your service history, invoices, and account information.': 'Inicia sesión para consultar tu historial de servicio, facturas e información de la cuenta.',
  'Email address': 'Correo electrónico',
  'Sending...': 'Enviando...',
  'Send me a login link': 'Enviarme un enlace de acceso',
  'Send me a new login link': 'Enviarme un nuevo enlace de acceso',
  'or': 'o',
  'Use the secure link from a recent email from your pool service provider.': 'Usa el enlace seguro de un correo reciente de tu proveedor de servicio de albercas.',
  'Link Expired': 'El enlace venció',
  'For your security, portal access links expire after a period of time.': 'Por tu seguridad, los enlaces de acceso al portal vencen después de cierto tiempo.',
  'Unable to Sign In': 'No se pudo iniciar sesión',
  "We couldn't verify your access link. This can happen if the link was copied incorrectly or has already been used.": 'No pudimos verificar tu enlace de acceso. Esto puede ocurrir si se copió incorrectamente o si ya se usó.',
  'No quote token provided.': 'No se proporcionó un token de cotización.',
  'Unable to load quote.': 'No se pudo cargar la cotización.',
  'Unable to Load Quote': 'No se pudo cargar la cotización',
  'This quote link may be invalid or expired.': 'Este enlace de cotización puede no ser válido o puede haber vencido.',
  'Quote Expired': 'La cotización venció',
  'This quote is no longer available. Please contact {{provider}} for an updated quote.': 'Esta cotización ya no está disponible. Comunícate con {{provider}} para solicitar una cotización actualizada.',
  'your service provider': 'tu proveedor de servicio',
  'Quote Approved!': '¡Cotización aprobada!',
  'Thank you for approving this quote. {{businessName}} has been notified and will be in touch regarding next steps.': 'Gracias por aprobar esta cotización. Notificamos a {{businessName}}, quien se comunicará contigo para indicarte los siguientes pasos.',
  'A deposit of {{amount}} is required. Your service provider will follow up with payment details.': 'Se requiere un depósito de {{amount}}. Tu proveedor de servicio se comunicará contigo con los detalles de pago.',
  'Quote Declined': 'Cotización rechazada',
  "You've declined this quote. If you change your mind or have questions, please contact {{provider}}.": 'Rechazaste esta cotización. Si cambias de opinión o tienes preguntas, comunícate con {{provider}}.',
  'Quote Already {{status}}': 'Cotización ya {{status}}',
  'This quote has already been {{status}}. No further action is needed.': 'Esta cotización ya fue {{status}}. No se requiere ninguna otra acción.',
  'approved': 'aprobada',
  'declined': 'rechazada',
  'Pending Approval': 'Pendiente de aprobación',
  'Prepared for': 'Preparada para',
  'Price': 'Precio',
  'Deposit Required': 'Depósito requerido',
  'This quote is valid until {{date}}': 'Esta cotización es válida hasta el {{date}}',
  'Reason for declining (optional)': 'Motivo del rechazo (opcional)',
  "Let us know if there's anything we can adjust...": 'Dinos si hay algo que podamos ajustar...',
  'Confirm Decline': 'Confirmar rechazo',
  'Approve Quote': 'Aprobar cotización',
  'Failed to load quote': 'No se pudo cargar la cotización',
  'Failed to approve quote': 'No se pudo aprobar la cotización',
  'Failed to decline quote': 'No se pudo rechazar la cotización',
  'No agreement token provided.': 'No se proporcionó un token del contrato.',
  'Failed to load agreement': 'No se pudo cargar el contrato',
  'Unable to load agreement.': 'No se pudo cargar el contrato.',
  'Failed to approve agreement': 'No se pudo aprobar el contrato',
  'Unable to Load Agreement': 'No se pudo cargar el contrato',
  'This link may be invalid.': 'Este enlace puede no ser válido.',
  'Agreement Approved!': '¡Contrato aprobado!',
  'Thank you for approving the service agreement. {{businessName}} has been notified and will be in touch.': 'Gracias por aprobar el contrato de servicio. Notificamos a {{businessName}}, quien se comunicará contigo.',
  'Go to Your Portal': 'Ir a tu portal',
  'Questions? Call {{phone}}': '¿Tienes preguntas? Llama al {{phone}}',
  'Already Approved': 'Ya aprobado',
  'This service agreement has already been approved. No further action is needed.': 'Este contrato de servicio ya fue aprobado. No se requiere ninguna otra acción.',
  'I have read and agree to the terms of this service agreement.': 'He leído y acepto los términos de este contrato de servicio.',
  'Approve Agreement': 'Aprobar contrato',
  'Questions? Contact {{businessName}}': '¿Tienes preguntas? Comunícate con {{businessName}}',
  'at': 'al',
  'Sign below': 'Firma abajo',
  'Draw your signature here': 'Dibuja tu firma aquí',
  'Clear signature': 'Borrar firma',
  'Service': 'Servicio',
  'Details': 'Detalles',
  'Booking progress': 'Progreso de la reservación',
  'Free': 'Gratis',
  'From {{price}}': 'Desde {{price}}',
  'Online booking is not available from this portal address.': 'La reservación en línea no está disponible desde esta dirección del portal.',
  'Online booking is not available right now.': 'La reservación en línea no está disponible en este momento.',
  'Your pool service company': 'Tu empresa de servicio de albercas',
  'Enter your name and phone number so the appointment can be confirmed.': 'Ingresa tu nombre y teléfono para que se pueda confirmar la cita.',
  'Unable to send your request. Please try again.': 'No se pudo enviar tu solicitud. Inténtalo de nuevo.',
  'Finding available appointments…': 'Buscando citas disponibles…',
  'Online appointment request': 'Solicitud de cita en línea',
  'No payment required': 'No se requiere pago',
  'What can we help with?': '¿En qué podemos ayudarte?',
  'Choose a service to see the next available dates.': 'Elige un servicio para ver las próximas fechas disponibles.',
  'Online booking is not available right now. Please contact {{businessName}} directly.': 'La reservación en línea no está disponible en este momento. Comunícate directamente con {{businessName}}.',
  'Back to services': 'Volver a servicios',
  'Choose a preferred date': 'Elige una fecha preferida',
  'Pick a day that works for you. {{businessName}} will confirm the exact arrival time.': 'Elige el día que prefieras. {{businessName}} confirmará la hora exacta de llegada.',
  'Selected service': 'Servicio seleccionado',
  'Choose {{date}}': 'Elegir {{date}}',
  'No dates are available right now. Please check back later.': 'No hay fechas disponibles en este momento. Vuelve a intentarlo más tarde.',
  'Back to dates': 'Volver a las fechas',
  'Where should we confirm your visit?': '¿Dónde debemos confirmar tu visita?',
  'Your phone number is required so {{businessName}} can confirm the appointment.': 'Se requiere tu teléfono para que {{businessName}} pueda confirmar la cita.',
  'Full name': 'Nombre completo',
  'Email (optional)': 'Correo electrónico (opcional)',
  'Service address': 'Dirección del servicio',
  'Anything else we should know? (optional)': '¿Hay algo más que debamos saber? (opcional)',
  'Appointment summary': 'Resumen de la cita',
  'Request summary': 'Resumen de la solicitud',
  'Preferred date': 'Fecha preferida',
  'No payment is collected. Your information is sent securely.': 'No se realizará ningún cobro. Tu información se envía de forma segura.',
  'Sending request…': 'Enviando solicitud…',
  'Send appointment request': 'Enviar solicitud de cita',
  'Your request is in': 'Recibimos tu solicitud',
  '{{businessName}} will contact you to confirm the arrival time for your {{serviceName}} visit.': '{{businessName}} se comunicará contigo para confirmar la hora de llegada para tu visita de {{serviceName}}.',
  'Booking powered by Pool Dial': 'Reservaciones con tecnología de Pool Dial',
  'Pool Service': 'Servicio de albercas',
  'This contact form is not available.': 'Este formulario de contacto no está disponible.',
  'Please provide your name and either an email address or phone number.': 'Ingresa tu nombre y un correo electrónico o teléfono.',
  'Unable to send your request.': 'No se pudo enviar tu solicitud.',
  'Request received': 'Solicitud recibida',
  '{{businessName}} will be in touch soon.': '{{businessName}} se comunicará contigo pronto.',
  'Request Pool Service': 'Solicitar servicio de alberca',
  'Tell us about your pool and how we can help.': 'Cuéntanos sobre tu alberca y cómo podemos ayudarte.',
  'This contact form is not currently available.': 'Este formulario de contacto no está disponible en este momento.',
  'Name': 'Nombre',
  'Service needed': 'Servicio necesario',
  'Weekly Pool Service': 'Servicio semanal de alberca',
  'Pool Repair': 'Reparación de alberca',
  'One-Time Cleaning': 'Limpieza única',
  'Other': 'Otro',
  'How did you hear about us?': '¿Cómo te enteraste de nosotros?',
  'Referral': 'Recomendación',
  'How can we help?': '¿Cómo podemos ayudarte?',
  'Sending…': 'Enviando…',
  'Request Service': 'Solicitar servicio',
  'No service agreement on file.': 'No hay un contrato de servicio registrado.',
  'Signed': 'Firmado',
  'Pending Signature': 'Firma pendiente',
  'Signature': 'Firma',
  'Date signed': 'Fecha de firma',
  'Customer portal': 'Portal del cliente',
  'Service time': 'Hora del servicio',
} as const;
